import { render } from "./RiWorldOff.vue?vue&type=template&id=3622baca"
import script from "./RiWorldOff.vue?vue&type=script&lang=js"
export * from "./RiWorldOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWorldOff.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3622baca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3622baca', __exports__)) {
    api.reload('3622baca', __exports__)
  }
  
  module.hot.accept("./RiWorldOff.vue?vue&type=template&id=3622baca", () => {
    api.rerender('3622baca', render)
  })

}


export default __exports__